// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable babel/camelcase, jsx-a11y/anchor-is-valid */
import * as React from "react"
import { connect } from "react-redux"
import InputField from "@kiwicom/orbit-components/lib/InputField"
import CloseIcon from "@kiwicom/orbit-components/lib/icons/Close"
import SearchIcon from "@kiwicom/orbit-components/lib/icons/Search"
import Stack from "@kiwicom/orbit-components/lib/Stack"
import * as R from "ramda"
import type { Dispatch } from "redux"
// @ts-expect-error: Flow to TS migration.
import { set } from "splitster-redux"
import styled from "styled-components" // eslint-disable-line no-restricted-imports
import Cookies from "js-cookie" // dynamic/debug cookies
import Button from "@kiwicom/orbit-components/lib/Button"
import Heading from "@kiwicom/orbit-components/lib/Heading"
import Text from "@kiwicom/orbit-components/lib/Text"

import type { Splitster } from "./records/Splitster"
import Table from "./Table"

const REASON_TEXTS = {
  usage: "usage number not satisfied",
  separate_test: "other test is running separated",
  user_group: "user group is not satisfied",
  config: "specified in config file",
} as const

type Props = {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: Dispatch<any>
  splitster: Splitster
}

type State = {
  query: string
}

const ToggleWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: ${({ theme }) => theme.orbit.space300} 0;
`

const Wrapper = styled.div`
  padding: ${({ theme }) => theme.orbit.space300};
`

const Config = styled.pre`
  background-color: ${({ theme }) => theme.orbit.paletteWhite};
  max-width: 100%;
  padding: ${({ theme }) => theme.orbit.space300};
`

const TestDetail = ({ test }: { test: unknown }) => {
  const [open, setOpen] = React.useState(false)

  return (
    <Stack direction="column" spacing="200">
      <Button size="small" type="secondary" onClick={() => setOpen(!open)}>
        {open ? "Hide" : "Show"} config detail
      </Button>
      {open && <Config>{JSON.stringify(test, null, 1)}</Config>}
    </Stack>
  )
}

const QUERY_INPUT_NAME = "debugSplitsterQueryInput"

class SplitsterDebug extends React.PureComponent<Props, State> {
  state = {
    query: "",
  }

  inputRef: {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    current: React.ElementRef<any>
  } = React.createRef()

  componentDidMount() {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (this.inputRef) {
      // @ts-expect-error: Flow to TS migration.
      this.inputRef.current.focus()
    }
  }

  handleQueryChange = (event: React.SyntheticEvent<HTMLInputElement>) => {
    this.setState({ query: event.currentTarget.value })
  }

  handleQueryClear = (event: React.SyntheticEvent<HTMLInputElement>) => {
    event.preventDefault()
    this.setState({ query: "" })

    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (this.inputRef) {
      // @ts-expect-error: Flow to TS migration.
      this.inputRef.current.focus()
    }
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleChange = (testId: any) => (variantId: any) => {
    const { dispatch } = this.props
    dispatch(set(testId, variantId, true))
  }

  render() {
    const { query } = this.state
    const { splitster } = this.props

    const tests = R.compose(
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      R.map(([key, item]: [any, any]) => ({
        ...item,
        id: key,
      })),
      R.toPairs,
    )(splitster.tests)

    const uppercasedQuery = query.toUpperCase()

    return (
      <Wrapper>
        <InputField
          type="text"
          name={QUERY_INPUT_NAME}
          label="Search splitster test"
          value={query}
          // @ts-expect-error: Flow to TS migration.
          ref={this.inputRef}
          placeholder="Test id or its id part"
          prefix={<SearchIcon ariaHidden />}
          suffix={
            query.length ? (
              // @ts-expect-error: Flow to TS migration.
              <a href="#" onClick={this.handleQueryClear}>
                <CloseIcon ariaHidden />
              </a>
            ) : null
          }
          onChange={this.handleQueryChange}
        />

        <ToggleWrapper>
          <Stack spacing="300">
            {R.compose(
              R.map((test) => (
                // @ts-expect-error: Flow to TS migration.
                <div key={test.id}>
                  <Stack direction="row" align="center" justify="between" spaceAfter="normal">
                    <Heading as="h3" type="title5">
                      {/* @ts-expect-error: Flow to TS migration. */}
                      {test.id}
                    </Heading>

                    {/* Fix this the next time the file is edited. (Flow to TS) */}
                    {/* prettier-ignore *//* eslint-disable-next-line @typescript-eslint/restrict-template-expressions *//* @ts-expect-error: Flow to TS migration. */}
                    {Cookies.get(`splitster_${test.id}_${test.version}`) && (
                      <Button
                        size="small"
                        type="secondary"
                        onClick={() => {
                          // Fix this the next time the file is edited. (Flow to TS)
                          // @ts-expect-error: Flow to TS migration.
                          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                          Cookies.remove(`splitster_${test.id}_${test.version}`)
                          this.forceUpdate()
                        }}
                      >
                        Clear
                      </Button>
                    )}
                  </Stack>

                  {/* @ts-expect-error: Flow to TS migration. */}
                  {test.description && <Text>{test.description}</Text>}
                  {/* @ts-expect-error: Flow to TS migration. */}
                  {test.disabled && test.disabledReason && (
                    <Text>
                      {/* @ts-expect-error: Flow to TS migration. */}
                      <strong>Disabled:</strong> {REASON_TEXTS[test.disabledReason]}
                    </Text>
                  )}
                  <Stack>
                    {/* @ts-expect-error: Flow to TS migration. */}
                    <Table test={test} handleChange={this.handleChange(test.id)} />
                    <Stack direction="row" justify="between" spaceAfter="normal">
                      <TestDetail test={test} />
                    </Stack>
                  </Stack>
                </div>
              )),
              // @ts-expect-error: Flow to TS migration.
              R.filter((item) => item.id.includes(uppercasedQuery)),
            )(tests)}
          </Stack>
        </ToggleWrapper>
      </Wrapper>
    )
  }
}

export default connect((state) => ({
  // @ts-expect-error: Flow to TS migration.
  splitster: state.splitster,
}))(SplitsterDebug)
